import { render, staticRenderFns } from "./SetPersonalInfo.vue?vue&type=template&id=23f6f272&scoped=true&"
import script from "./SetPersonalInfo.vue?vue&type=script&lang=js&"
export * from "./SetPersonalInfo.vue?vue&type=script&lang=js&"
import style0 from "./SetPersonalInfo.vue?vue&type=style&index=0&id=23f6f272&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f6f272",
  null
  
)

export default component.exports